<template>
  <footer class="border-t border-gray-100 dark:border-gray-800 mt-16">
    <div class="max-w-4xl mx-auto px-4 py-10 space-y-6 text-center">
      <div class="space-y-1.5">
        <h3 class="text-sm font-semibold uppercase tracking-wide text-gray-700 dark:text-gray-200">
          About Rozay.today
        </h3>
        <p class="text-sm leading-6 text-gray-600 dark:text-gray-300">
          Rozay.today is an Islamic utility platform providing Ramadan calendar, Sehri &amp; Iftar times,
          Zakat calculator and daily Islamic tools for Pakistan.
        </p>
      </div>

      <div class="flex flex-col sm:flex-row sm:flex-wrap sm:justify-center gap-4 text-sm text-gray-700 dark:text-gray-200">
        <div class="basis-full sm:basis-[45%] border border-gray-100 dark:border-gray-800 rounded-lg p-4 space-y-1.5 text-left sm:text-left">
          <h4 class="font-semibold text-gray-800 dark:text-gray-100">Founder</h4>
          <p class="leading-6 text-gray-600 dark:text-gray-300">
            Built and maintained by Muzamil Qadir, a solo developer from Pakistan.
          </p>
        </div>
        <div class="basis-full sm:basis-[45%] border border-gray-100 dark:border-gray-800 rounded-lg p-4 space-y-1.5 text-left sm:text-left">
          <h4 class="font-semibold text-gray-800 dark:text-gray-100">Contact</h4>
          <p class="leading-6">
            Email:
            <a
              href="mailto:contact@rozay.today"
              class="text-emerald-700 dark:text-emerald-300 hover:underline"
            >
              contact@rozay.today
            </a>
          </p>
        </div>
        <div class="basis-full sm:basis-[45%] border border-gray-100 dark:border-gray-800 rounded-lg p-4 space-y-1.5 text-left sm:text-left">
          <h4 class="font-semibold text-gray-800 dark:text-gray-100">Location</h4>
          <p class="leading-6 text-gray-600 dark:text-gray-300">Pakistan</p>
        </div>
        <div class="basis-full sm:basis-[45%] border border-gray-100 dark:border-gray-800 rounded-lg p-4 space-y-2 text-left sm:text-left">
          <h4 class="font-semibold text-gray-800 dark:text-gray-100">Links</h4>
          <div class="flex flex-wrap gap-2">
            <NuxtLink
              v-for="link in trustLinks"
              :key="link.to"
              :to="link.to"
              class="px-3 py-1 rounded-full border border-gray-200 dark:border-gray-700 hover:border-emerald-500 dark:hover:border-emerald-400 transition-colors"
            >
              {{ link.label }}
            </NuxtLink>
          </div>
        </div>
      </div>

      <div class="text-xs text-gray-500 dark:text-gray-400">
        © 2026 Rozay.today. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const trustLinks = [
  { to: "/eid/", label: "Eid Mubarak" },
  { to: "/jumma-tul-wida/", label: "Jumma-tul-Wida" },
  { to: "/fitrana/", label: "Fitrana" },
  { to: "/zikr/", label: "Zikr" },
  { to: "/asma/", label: "Asma Ul Husna" },
  { to: "/privacy/", label: "Privacy Policy" },
  { to: "/terms/", label: "Terms & Conditions" },
  { to: "/about/", label: "About Us" },
  { to: "/contact/", label: "Contact" },
  { to: "/disclaimer/", label: "Disclaimer" },
];
</script>
